import type { ComponentType } from 'react';

export type InputAdornmentButtonVariant = 'default' | 'danger';

export interface InputAdornmentButtonProps {
  icon: ComponentType<{ size?: number }>;
  ariaLabel: string;
  onClick?: () => void;
  disabled?: boolean;
  /** `'danger'` swaps the hover tint to red (`#FEE5E6` / `#FA979B`) — use for delete / destructive actions. Default is blue. */
  variant?: InputAdornmentButtonVariant;
}

/**
 * InputAdornmentButton — icon-button chrome tuned for embedding inside a
 * 28px `<NewInput />` row via its `startAdornment` / `endAdornment` slots.
 * Renders a `<button>` with `.bombiix-input__adornment-btn` — hover + focus
 * states are handled by the shared `_input.scss` partial. Pair with any
 * icon from `src/bombiix-icon` (16px SVG size matches the input row).
 */
export function InputAdornmentButton({ icon: Icon, ariaLabel, onClick, disabled, variant = 'default' }: InputAdornmentButtonProps) {
  const btnClass = [
    'bombiix-input__adornment-btn',
    variant === 'danger' ? 'bombiix-input__adornment-btn--danger' : '',
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button type="button" className={btnClass} aria-label={ariaLabel} onClick={onClick} disabled={disabled}>
      <Icon size={16} />
    </button>
  );
}

export default InputAdornmentButton;
